import photoAndrey from '../../../shared/assets/photo/Veruzhskii.png';
import photoDenis from '../../../shared/assets/photo/Mochalov.png';


export const doctorsData = [
    {
        id: 1,
        img: photoAndrey,
        title: 'Верюжский Андрей Александрович',
        speciality: 'Стоматолог-терапевт-ортопед',
    },
    {
        id: 2,
        img: photoDenis,
        title: 'Мочалов Денис Константинович',
        speciality: 'Стоматолог-хирург-имплантолог',
    },
]